module.exports = __webpack_public_path__ + "templates.coupon-v2-6748f51c.html";